import axiosInstance from "../../../axios/axiosConfig"

export const calculateProjectedMeters = async (order) => {
  if (!order?.selectedProduct?.knifeCode || order.selectedProduct.knifeCode === "none") {
    return { ...order, projectedMeters: 0 }
  }

  try {
    const response = await axiosInstance.get(
      `/api/searchByCode?code=${encodeURIComponent(order.selectedProduct.knifeCode)}`,
    )
    const knife = response.data

    const countInThousands = order.labelCount / 1000
    const correctColumns = order.selectedProduct.numberOfColumns
    const a1 = (knife.height + knife.gapRaport) * 0.001
    const a2 = (1000 / correctColumns).toFixed(2)
    const a3 = Math.ceil(a1 * a2)
    const projectedMeters = Math.round(a3 * countInThousands)

    return { ...order, projectedMeters }
  } catch (error) {
    console.error(`Failed to fetch knife data for order ${order.orderNumber}:`, error)
    return { ...order, projectedMeters: 0 }
  }
}
